import { SelectorValue } from 'types/types';

export const getFacilitiesId = (facilities: string | SelectorValue[]): string[] => {
  if (typeof facilities === 'string') {
    return [facilities];
  }

  return facilities.map((facility) => facility.id.toString());
};
